import { render, staticRenderFns } from "./LabourSection.vue?vue&type=template&id=2d425192"
import script from "./LabourSection.vue?vue&type=script&lang=js"
export * from "./LabourSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports